import HubSpotClient from '../clients/HubSpot/HubSpotClient';
import { ITabStateProvider } from './ITabStateProvider';
import { SearchEntryState } from './SearchEntryState';
import { SearchTabState } from './SearchTabState';
import { HsListResult } from '../clients/HubSpot/Models/HsListResult';

export class HubSpotTabStateProvider implements ITabStateProvider {
    client: HubSpotClient;
    entriesPerPage: number;

    constructor(client: HubSpotClient, entriesPerPage: number) {
        this.client = client;
        this.entriesPerPage = entriesPerPage;
    }

    async GetTabs(query: string): Promise<Array<SearchTabState>> {
        const tabState = new SearchTabState('Articles', 'pages', this);
        if (query === '' || !query) {
            return [tabState];
        }

        const result = await this.client.getHubSpotResults(query);
        tabState.patch(this.map(result, query));

        return [
            tabState
        ];
    }

    private map(result: HsListResult, query: string): Partial<SearchTabState> {
        return {
            allPages: Math.ceil(result.total / this.entriesPerPage),
            entries: result.results.map(x => new SearchEntryState('Articles', x.title, x.url, x.description, x.tags, '')),
            page: Math.ceil(result.offset / this.entriesPerPage),
            count: result.total,
            query: query
        };
    }

    async Update(page: number, issuer: SearchTabState): Promise<void> {
        var lastQuery = issuer.query;

        const result = await this.client.getHubSpotResults(lastQuery, page * this.entriesPerPage);
        issuer.patch(this.map(result, lastQuery));
    }
}
